import deleteRequestNetworkAction from '../../../../network/actions/delete-request'
import REDUX_ACTION from '../../../../redux/constants/action'

/**
 * Sets the given `path` status as error and set the error.
 * @private
 * @param {Object} action
 *        {Object} action.payload
 *        {string} [action.payload.path]
 *        {string} [action.payload.domainListPath]
 *        {Object} action.payload.error
 */
export default function loadErrorReduxAction (action) {
  return (dispatch) => {
    // loadErrorReduxActionLogger.debug(action)
    dispatch(deleteRequestNetworkAction(action))
    dispatch({
      type: action.type + '_ERROR',
      payload: action.payload,
      reduxType: REDUX_ACTION.LOAD_ERROR
    })
  }
}
